var React = require('react');

function Account (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h16v16H0z","key":0}),React.createElement("circle",{"cx":"3.333","cy":"3.667","r":"3","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","transform":"translate(4.667 .333)","key":1}),React.createElement("path",{"stroke":"#000","strokeWidth":"2","d":"M1 16v-1.333C1 12.089 3.194 10 5.9 10h4.2c2.706 0 4.9 2.09 4.9 4.667V16","key":2})]));
}

Account.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Account;

Account.default = Account;
